import { Injectable } from '@angular/core'
import { loginUrl } from '../config/api'
import * as authJSON from  '../../builder/allus/auth.json'
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpClient,
    HttpHeaders,
    HttpParams
} from '@angular/common/http'

import { Observable, throwError } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr'

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

    tentativas: number = 0
    constructor (
        private http: HttpClient,
        private toastService: ToastrService
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token: string = localStorage.getItem('token')

        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', token) })
        }

        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') })
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') })
        
        let isAnonymous = false
        if (request.headers.has('Anonymous')) {
            isAnonymous = true
            let newHeaders = request.headers.delete('Anonymous')
            request = request.clone({ headers: newHeaders })
        }

        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log(event)
                }
                return event
            }),
            catchError((error: HttpErrorResponse) => {
                if (!isAnonymous) {
                    if (error.status === 401) {
                        let credentials = (authJSON as any).default
                        if (credentials.username && credentials.password) {
                            this.toastService.info('Tentando fazer login com as credencias do allus-builder...')
                            this.login(credentials.username, credentials.password)
                        } else {
                            this.toastService.info('Parece que não há nenhuma informação de login. Execute o comando allus login.', null, {
                                timeOut: 5000
                            })
                        }
                    }
                }
                return throwError(error)
            }))
    }

    login (username, password) {
        let headers = new HttpHeaders({
            'Content-Type':  'application/x-www-form-urlencoded',
            'Anonymous': 'true'
          })
      
          let body = new HttpParams()
            .set(`identificador`, username)
            .set(`senha`, password);
        
          this.http.post(loginUrl, body.toString(), {
            headers: headers,
            responseType: 'text'
          }).subscribe(token => {
            localStorage.setItem('token', token)
            window.location.reload()
          }, err => {
              console.log(err)
            this.toastService.info('Parece que as credenciais estão inválidas. Execute o comando npm run builder:login novamente.')
          })
    }
}